import PropTypes from "prop-types";
import { useEffect } from "react";
import FormModal from "../../../../core/ui/components/FormModal";
import { Input, Row, Col } from "reactstrap";
import Button from "../../../../core/ui/components/Button";

import { Controller, useForm } from "react-hook-form";
import { toast } from "../../../../core/helpers/message-helper";
import InputController from "../../../../core/ui/components/InputController";
import { selectTurnosSedes } from "../../../NominaTurnos/services/nomina-turnos-service";
import SelectController from "../../../../core/ui/components/SelectController";
import { useState } from "react";
import { useReducer } from "react";
import { secuenciaReducer } from "../../reducers/secuencia-reducer";
import { crearOEditarSecuencia } from "../../services/nomina-secuencias-service";

import "./styles.css";
import SecuenciaTurnos from "./secuencia-turnos";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const FormSecuenciasTurnos = ({ onCreated, modalState }) => {
    const [turnosSedes, setTurnosSedes] = useState([]);
    const [secuencia, accionSecuencia] = useReducer(secuenciaReducer, []);

    const data = modalState.data.secuencia;

    const trabajaFestivos = {
        label: data.trabaja_festivos == 1 ? "SI" : "NO",
        value: data.trabaja_festivos == 1 ? 1 : 0,
    };

    const defaultValues = {
        id: data.id ?? "",
        nombre: data.nombre ? data.nombre : "",
        horas_dia: data.horas_dia ?? "",
        max_horas_extras_dia: data.max_horas_extras_dia ?? "",
        max_horas_extras_semana: data.max_horas_extras_semana ?? "",
        max_horas_turnos_seguidos: data.max_horas_turnos_seguidos ?? "",
        trabaja_festivos: trabajaFestivos,
        turno: "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => {
        form.reset(defaultValues);
        accionSecuencia({
            tipo: "llenar",
            valor: data.secuencia_turnos_sedes ?? [],
        });
    }, [modalState.data.secuencia]);

    const onEliminarTurno = (idTurno, indice) => {
        accionSecuencia({
            tipo: "eliminar",
            valor: indice,
            idTurno,
        });
    };

    const agregarTurnoASecuencia = () => {
        const turno = form.getValues("turno");
        if (!turno.id) return;

        accionSecuencia({
            tipo: "agregar",
            valor: {
                id: turno.id,
                sede: turno.sede,
                sigla: turno.sigla,
                color: turno.color,
            },
        });

        form.setValue("turno", "");
    };

    useEffect(async () => {
        const resp = await selectTurnosSedes();
        if (!resp.status) return toast.error(resp.message);

        setTurnosSedes(
            resp.data.map((turno) => {
                return {
                    color: turno.color,
                    id: turno.id,
                    sigla: turno.sigla,
                    sede: turno.sede,
                    value: turno.id,
                    label: turno.info_asignacion_turno,
                };
            })
        );
    }, []);

    async function onSubmit(data) {
        if (secuencia.length < 2) {
            return toast.error(
                "Debes agregar al menos 2 turnos a la secuencia"
            );
        }

        const datosSecuencia = {
            ...data,
            trabaja_festivos: data.trabaja_festivos?.value ?? 0,
            secuencia_turnos_sedes: secuencia.map((turno) => turno.id),
        };

        const resp = await crearOEditarSecuencia(datosSecuencia);
        if (!resp.status) toast.error(resp.message);
        onCreated && onCreated(resp);
        accionSecuencia({ tipo: "llenar", valor: [] });
    }

    const opcionesTrabajaFestivos = [
        { value: 1, label: "SI" },
        { value: 0, label: "NO" },
    ];

    return (
        <FormModal
            size="xl"
            form={form}
            id="formSecuencias"
            onSubmit={onSubmit}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() =>
                modalState.set({
                    show: false,
                    data: { ...modalState.data, secuencia: {} },
                })
            }
        >
            <Row>
                <Controller
                    name="id"
                    control={form.control}
                    render={({ field }) => (
                        <Input
                            id="id"
                            value={field.value ?? ""}
                            type="hidden"
                            {...field}
                        />
                    )}
                />
                <Col lg={4}>
                    <InputController
                        type="text"
                        label="Nombre de la secuencia"
                        name="nombre"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Horas laborales del día"
                        name="horas_dia"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        rules={REQUIRED_RULE}
                        label="¿Trabaja festivos?"
                        name="trabaja_festivos"
                        options={opcionesTrabajaFestivos}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Máximo horas turnos seguidos"
                        name="max_horas_turnos_seguidos"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Máximo horas extras (dia)"
                        name="max_horas_extras_dia"
                        control={form.control}
                        errors={form.formState.errors}
                    />
                </Col>
                <Col lg={4}>
                    <InputController
                        type="number"
                        label="Máximo horas extras (semana)"
                        name="max_horas_extras_semana"
                        control={form.control}
                        errors={form.formState.errors}
                        rules={REQUIRED_RULE}
                    />
                </Col>
            </Row>
            <h4 className="text-center w-100 py-2">ESTABLECER SECUENCIA</h4>
            <Row>
                <Col lg={6} className="mx-auto">
                    <Row>
                        <Col lg="9">
                            <SelectController
                                name="turno"
                                options={turnosSedes}
                                control={form.control}
                                errors={form.formState.errors}
                                placeholder="Seleccionar turno..."
                            />
                        </Col>
                        <Col lg="3">
                            <Button onClick={agregarTurnoASecuencia}>
                                <i className="fas fa-plus mr-2"></i>
                                Agregar
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <h6 className="text-center mt-4">Secuencia Actual</h6>
            <SecuenciaTurnos
                secuencia={secuencia}
                onEliminarTurno={onEliminarTurno}
            />
        </FormModal>
    );
};

FormSecuenciasTurnos.propTypes = {
    modalState: PropTypes.object,
    onCreated: PropTypes.func,
};

export default FormSecuenciasTurnos;
